import React, { createContext, useContext, useEffect, useRef } from 'react';

import { createMetricsTransport, MetricsTransport } from '../services/metricsService';

const MetricsContext = createContext<MetricsTransport | null>(null);

export const MetricsProvider = ({ children }: { children: React.ReactNode }) => {
  const transport = useRef(createMetricsTransport());

  useEffect(() => {
    const currTransport = transport.current;
    return () => currTransport.destroy();
  }, []);

  return <MetricsContext.Provider value={transport.current}>{children}</MetricsContext.Provider>;
};

export const useMetricsTransport = (): MetricsTransport => {
  const ctx = useContext(MetricsContext);
  if (!ctx) throw new Error('useMetricsTransport must be used within MetricsProvider');
  return ctx;
};
